import swiper from "swiper";



//--------------------------------------------------------
//スライド
//--------------------------------------------------------
var caseSlideCount = $('.case-contents-single__wrap').find(".swiper-slide").length;
if (caseSlideCount > 1) {
  //console.log(caseSlideCount);
  var caseSlideNav = new swiper(".case-contents-single__slide__wrap", {
    slidesPerView: 1,
    speed: 1500,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    slidesPerView: "auto",
    loop: true,
    onSlideChangeEnd : (s) => {s.fixLoop();},
    centeredSlides : true,
    disableOnInteraction: true,
    slideToClickedSlide: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    //breakpoints: {
      // 960: {
      //   slidesPerView: 2
      // },
      // 414: {
      //   autoHeight: false,
      //   slidesPerView: 1
      // }
    //},
    navigation: {
      nextEl: ".case-contents-single__slide-next",
      prevEl: ".case-contents-single__slide-prev",
    }
  });
} else {
  $('.case-contents-single__wrap').find(".case-contents-single__slide-next").hide();
  $('.case-contents-single__wrap').find(".case-contents-single__slide-prev").hide();
  $('.case-contents-single__wrap').find(".case-contents-single__slide-pagination").hide();
}





//--------------------------------------------------------
//1
//--------------------------------------------------------
var caseSlideCount01 = $('.caseSlide01').find(".swiper-slide").length;
if (caseSlideCount01 > 1) {
  //console.log(caseSlideCount);
  var caseSlideNav01 = new swiper(".caseSlide01", {
    slidesPerView: 1,
    speed: 1500,
    // autoplay: {
    //   delay: 3000,
    //   disableOnInteraction: false,
    // },
    slidesPerView: "auto",
    loop: true,
    onSlideChangeEnd : (s) => {s.fixLoop();},
    centeredSlides : true,
    disableOnInteraction: true,
    slideToClickedSlide: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".caseSlide01-next",
      prevEl: ".caseSlide01-prev",
    }
  });
} else {
  $('.case-contents-single-detaile__wrap').find(".caseSlide01-next").hide();
  $('.case-contents-single-detaile__wrap').find(".caseSlide01-prev").hide();
  $('.case-contents-single-detaile__wrap').find(".caseSlide01-next-pagination").hide();
}



//--------------------------------------------------------
//2
//--------------------------------------------------------
var caseSlideCount02 = $('.caseSlide02').find(".swiper-slide").length;
if (caseSlideCount02 > 1) {
  //console.log(caseSlideCount);
  var caseSlideNav02 = new swiper(".caseSlide02", {
    slidesPerView: 1,
    speed: 1500,
    // autoplay: {
    //   delay: 3000,
    //   disableOnInteraction: false,
    // },
    slidesPerView: "auto",
    loop: true,
    onSlideChangeEnd : (s) => {s.fixLoop();},
    centeredSlides : true,
    disableOnInteraction: true,
    slideToClickedSlide: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".caseSlide02-next",
      prevEl: ".caseSlide02-prev",
    }
  });
} else {
  $('.case-contents-single-detaile__wrap').find(".caseSlide02-next").hide();
  $('.case-contents-single-detaile__wrap').find(".caseSlide02-prev").hide();
  $('.case-contents-single-detaile__wrap').find(".caseSlide02-next-pagination").hide();
}



//--------------------------------------------------------
//3
//--------------------------------------------------------
var caseSlideCount03 = $('.caseSlide03').find(".swiper-slide").length;
if (caseSlideCount03 > 1) {
  //console.log(caseSlideCount);
  var caseSlideNav03 = new swiper(".caseSlide03", {
    slidesPerView: 1,
    speed: 1500,
    // autoplay: {
    //   delay: 3000,
    //   disableOnInteraction: false,
    // },
    slidesPerView: "auto",
    loop: true,
    onSlideChangeEnd : (s) => {s.fixLoop();},
    centeredSlides : true,
    disableOnInteraction: true,
    slideToClickedSlide: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".caseSlide03-next",
      prevEl: ".caseSlide03-prev",
    }
  });
} else {
  $('.case-contents-single-detaile__wrap').find(".caseSlide03-next").hide();
  $('.case-contents-single-detaile__wrap').find(".caseSlide03-prev").hide();
  $('.case-contents-single-detaile__wrap').find(".caseSlide03-next-pagination").hide();
}

//--------------------------------------------------------
//4
//--------------------------------------------------------
var caseSlideCount04 = $('.caseSlide04').find(".swiper-slide").length;
if (caseSlideCount04 > 1) {
  //console.log(caseSlideCount);
  var caseSlideNav04 = new swiper(".caseSlide04", {
    slidesPerView: 1,
    speed: 1500,
    // autoplay: {
    //   delay: 3000,
    //   disableOnInteraction: false,
    // },
    slidesPerView: "auto",
    loop: true,
    onSlideChangeEnd : (s) => {s.fixLoop();},
    centeredSlides : true,
    disableOnInteraction: true,
    slideToClickedSlide: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".caseSlide04-next",
      prevEl: ".caseSlide04-prev",
    }
  });
} else {
  $('.case-contents-single-detaile__wrap').find(".caseSlide04-next").hide();
  $('.case-contents-single-detaile__wrap').find(".caseSlide04-prev").hide();
  $('.case-contents-single-detaile__wrap').find(".caseSlide04-next-pagination").hide();
}


//--------------------------------------------------------
//5
//--------------------------------------------------------
var caseSlideCount05 = $('.caseSlide05').find(".swiper-slide").length;
if (caseSlideCount05 > 1) {
  //console.log(caseSlideCount);
  var caseSlideNav05 = new swiper(".caseSlide05", {
    slidesPerView: 1,
    speed: 1500,
    // autoplay: {
    //   delay: 3000,
    //   disableOnInteraction: false,
    // },
    slidesPerView: "auto",
    loop: true,
    onSlideChangeEnd : (s) => {s.fixLoop();},
    centeredSlides : true,
    disableOnInteraction: true,
    slideToClickedSlide: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".caseSlide05-next",
      prevEl: ".caseSlide05-prev",
    }
  });
} else {
  $('.case-contents-single-detaile__wrap').find(".caseSlide05-next").hide();
  $('.case-contents-single-detaile__wrap').find(".caseSlide05-prev").hide();
  $('.case-contents-single-detaile__wrap').find(".caseSlide05-next-pagination").hide();
}


//--------------------------------------------------------
//6
//--------------------------------------------------------
var caseSlideCount06 = $('.caseSlide06').find(".swiper-slide").length;
if (caseSlideCount06 > 1) {
  //console.log(caseSlideCount);
  var caseSlideNav06 = new swiper(".caseSlide06", {
    slidesPerView: 1,
    speed: 1500,
    // autoplay: {
    //   delay: 3000,
    //   disableOnInteraction: false,
    // },
    slidesPerView: "auto",
    loop: true,
    onSlideChangeEnd : (s) => {s.fixLoop();},
    centeredSlides : true,
    disableOnInteraction: true,
    slideToClickedSlide: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".caseSlide06-next",
      prevEl: ".caseSlide06-prev",
    }
  });
} else {
  $('.case-contents-single-detaile__wrap').find(".caseSlide06-next").hide();
  $('.case-contents-single-detaile__wrap').find(".caseSlide06-prev").hide();
  $('.case-contents-single-detaile__wrap').find(".caseSlide06-next-pagination").hide();
}


//--------------------------------------------------------
//7
//--------------------------------------------------------
var caseSlideCount07 = $('.caseSlide07').find(".swiper-slide").length;
if (caseSlideCount07 > 1) {
  //console.log(caseSlideCount);
  var caseSlideNav07 = new swiper(".caseSlide07", {
    slidesPerView: 1,
    speed: 1500,
    // autoplay: {
    //   delay: 3000,
    //   disableOnInteraction: false,
    // },
    slidesPerView: "auto",
    loop: true,
    onSlideChangeEnd : (s) => {s.fixLoop();},
    centeredSlides : true,
    disableOnInteraction: true,
    slideToClickedSlide: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".caseSlide07-next",
      prevEl: ".caseSlide07-prev",
    }
  });
} else {
  $('.case-contents-single-detaile__wrap').find(".caseSlide07-next").hide();
  $('.case-contents-single-detaile__wrap').find(".caseSlide07-prev").hide();
  $('.case-contents-single-detaile__wrap').find(".caseSlide07-next-pagination").hide();
}


//--------------------------------------------------------
//8
//--------------------------------------------------------
var caseSlideCount08 = $('.caseSlide08').find(".swiper-slide").length;
if (caseSlideCount08 > 1) {
  //console.log(caseSlideCount);
  var caseSlideNav08 = new swiper(".caseSlide08", {
    slidesPerView: 1,
    speed: 1500,
    // autoplay: {
    //   delay: 3000,
    //   disableOnInteraction: false,
    // },
    slidesPerView: "auto",
    loop: true,
    onSlideChangeEnd : (s) => {s.fixLoop();},
    centeredSlides : true,
    disableOnInteraction: true,
    slideToClickedSlide: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".caseSlide08-next",
      prevEl: ".caseSlide08-prev",
    }
  });
} else {
  $('.case-contents-single-detaile__wrap').find(".caseSlide08-next").hide();
  $('.case-contents-single-detaile__wrap').find(".caseSlide08-prev").hide();
  $('.case-contents-single-detaile__wrap').find(".caseSlide08-next-pagination").hide();
}

